export const GET_APP_CONTACT = 'GET_APP_CONTACT'//获取联系信息
export const ADD_APP_CONTACT = 'ADD_APP_CONTACT'//添加联系信息
export const UPDATE_APP_CONTACT = 'UPDATE_APP_CONTACT'//修改联系信息
export const DELETE_APP_CONTACT = 'DELETE_APP_CONTACT'//删除联系信息